import Image from 'next/image';
import { useEffect, useState } from 'react';

export type ItemImageProps = {
  itemId: string;
  height?: number;
  scale: number;
  imageNumber: number;
  onImageNotFound?: () => {};
};

export default function ItemImage(props: ItemImageProps) {
  const [imgSrc, setImgSrc] = useState<string | undefined>(undefined);
  const { itemId, imageNumber } = props;
  const sessionStorageName = `[${props.itemId}][${props.imageNumber}].noImage`;
  const fallBackSrc = '/noimageavailable.jpg';

  useEffect(() => {
    setImgSrc(getImageUrl());
  }, [itemId, imageNumber]);

  const noImage = !!window.sessionStorage.getItem(sessionStorageName);

  const getImageUrl = () =>
    (!noImage &&
      `${
        process.env.NEXT_PUBLIC_CDN_URL
      }?itemId=${itemId}&imageIndex=${imageNumber}&width=${
        props.scale * 120
      }`) ||
    fallBackSrc;

  return (
    (itemId && (
      <div
        style={{
          position: 'relative',
          width: '100%',
          height: props.height * props.scale,
        }}
      >
        <Image
          src={imgSrc}
          onError={() => {
            setImgSrc(fallBackSrc);
            // Do not try loading the missing image from CDN
            // if the image does not exist for this browser session.
            window.sessionStorage.setItem(sessionStorageName, 'true');
            props.onImageNotFound?.();
          }}
          onLoad={() => {
            if (window.sessionStorage.getItem(sessionStorageName) === 'true') {
              props.onImageNotFound?.();
            }
          }}
          alt={`${itemId}`}
          style={{ objectFit: 'contain' }}
          fill
          sizes='25vw'
        />
      </div>
    )) ||
    null
  );
}
